import React, { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";

export default function LiveCenterWithOdds() {
    const [searchParams] = useSearchParams();

    const h = searchParams.get("h");
    const a = searchParams.get("a");
    const lc = searchParams.get("lc");

    const url = "https://realtimecig.inplay.club/livecenter-v2/index.html?l="+localStorage.getItem("lang")+"&h="+h+"&a="+a+"&c=PA&t=o#"+lc;

    return (
        <div style={{ height: "100vh", overflow: "hidden" }}>
            <iframe
                src={url}
                id="_iLiveCenter"
                name="_iLiveCenter"
                width="100%"
                height="100%"
                style={{ border: "none", overflow: "hidden" }}
                allowFullScreen
                loading="lazy"
                referrerPolicy="no-referrer"
                sandbox="allow-scripts allow-same-origin allow-forms"
            ></iframe>
        </div>
    );
}